module.exports = __webpack_public_path__ + "img/sponsorS04.247e1292.png";